import { render, staticRenderFns } from "./TextFieldBlock.vue?vue&type=template&id=1375fd2b"
import script from "./TextFieldBlock.vue?vue&type=script&lang=ts"
export * from "./TextFieldBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports